import { createAction } from '@ngrx/store';

export const downloadProductReferential = createAction(
  '[Product Referential] Download Product Referentiel'
);
